<script setup lang="ts">
import NotificationContainer from './components/notification/NotificationContainer.vue'
import AlertDialog from './components/dialogs/AlertDialog.vue'
import AccountLegalNavigation from './components/account/legal/AccountLegalNavigation.vue'
import { useLegalAccountDataState } from './utilities/account/useAccountDataLegal'
import AccountLegalPanel from './components/account/legal/AccountLegalPanel.vue'
import LoadingSpinner from './components/base/LoadingSpinner.vue'
import { navigateToNextPageWithMissingFieldsForInvestmentLegal } from './utilities/account/useAccountNavigationLegal'
import { useLegalAccountFormState } from './utilities/account/useAccountFormLegal'
import { ref, watchEffect } from 'vue'
import { usePortfolio } from './utilities/portfolio/usePortfolio'
import { useWalletState } from './utilities/account/useWallet'

const state = useLegalAccountDataState()

const {
    getOrdersPerIssuerAccepted,
    getOpenInvestments,
    getOrdersPerIssuerActiveItems,
    getOrdersPerIssuerCompletedItems,
} = usePortfolio()
const { fetchWalletData } = useWalletState()

const panel = ref<HTMLElement | null>(null)

function scrollIntoView() {
    if (window.innerWidth < 1024) {
        panel.value.scrollIntoView({ behavior: 'smooth' })
    }
}

watchEffect(async () => {
    const urlParams = new URLSearchParams(window.location.search)
    const action = urlParams.get('action')

    await state.fetchAccountData()
    await fetchWalletData()

    if (state.accountId && window.condaUseV2FrontendPortfolioDashboard) {
        getOrdersPerIssuerAccepted(state.accountId)
        getOpenInvestments(state.accountId)
        getOrdersPerIssuerActiveItems(state.accountId)
        getOrdersPerIssuerCompletedItems(state.accountId)
    }

    if (action === 'missingDataProcessForVerification') {
        const accountFormState = useLegalAccountFormState()
        accountFormState.missingDataProcessForVerificationActive = true
        navigateToNextPageWithMissingFieldsForInvestmentLegal()
    }
})
</script>

<template>
    <div class="bg-gray-50">
        <NotificationContainer />
        <AlertDialog />
        <div v-if="state.loaded" class="space-x-0 space-y-6 pb-12 pt-8 lg:flex lg:space-x-7 lg:space-y-0">
            <nav class="w-full lg:w-1/4">
                <AccountLegalNavigation @navigate="scrollIntoView" />
            </nav>
            <main ref="panel" class="w-full !pt-0 lg:w-3/4">
                <AccountLegalPanel />
            </main>
        </div>
        <div v-else class="flex h-[65vh] items-center justify-center">
            <LoadingSpinner class="h-10 w-10 fill-primary" />
        </div>
    </div>
</template>

<style scoped></style>
